<template>
  <div class="animated fadeIn">
    <basic-heading class="mb-3" title="Schedule Calendar">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <div class="calendar">
      <full-calendar
        :events="events"
        firstDay="1"
        class="custom-calendar-styles"
        @changeMonth="changeMonth"
        @eventClick="eventClick"
        @dayClick="dayClick"
        @moreClick="moreClick"
      >
        <template #fc-header-left v-if="loading">
          <i class="fal fa-spinner fa-spin" /> Schedule Loading...
        </template>
      </full-calendar>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FullCalendar from "vue-fullcalendar";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import { mapActions, mapGetters } from "vuex";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "ScheduleCalendar",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    FullCalendar,
  },
  data() {
    return {
      loading: true,
      collection: null,
      events: [],
    };
  },
  computed: {
    ...mapGetters({ selected_date: "selectedDate" }),
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/schedules",
            title: "To Schedules list",
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions(["SET_SELECTED_DATE"]),
    setDate(day) {
      this.SET_SELECTED_DATE(moment(day).format("YYYY-MM-DD"));
    },
    dayClick(day, jsEvent) {
      this.setDate(day);
      this.$router.push(`/schedules/add/${this.selected_date}`);
    },
    async fetchSchedules(month_start = this.selected_date) {
      this.loading = true;

      this.collection = await getCollection({
        collection_type: "schedule",
        filters: [
          {
            logic: "filterGreaterEqual",
            field: "date",
            value: moment(month_start).startOf('month').format('YYYY-MM-DD')
          },
          {
            logic: "filterLessEqual",
            field: "date",
            value: moment(month_start).endOf('month').format('YYYY-MM-DD')
          },
        ],
        limit: "all",
        message: this.$bvToast,
      });

      this.createEventList();

      this.loading = false;
    },
    createEventList() {
      this.events = this.collection.models
        .filter((schedule) => schedule.current_schedule_status_log)
        .reduce((acc, cur) => {
          const { status } = cur.current_schedule_status_log.schedule_status;
          const check = acc.find(
            (item) => item.start === cur.date && item.data.status === status
          );

          if (check) {
            acc = acc.map((item) => {
              if (
                item.start === check.start &&
                item.data.status === check.data.status
              ) {
                return {
                  ...check,
                  title: `${check.data.schedule.length + 1} ${status}`,
                  data: {
                    ...check.data,
                    schedule: [...check.data.schedule, cur],
                  },
                };
              }

              return item;
            });
          } else {
            acc = [
              ...acc,
              {
                title: `1 ${status}`,
                start: cur.date,
                cssClass: status.toLowerCase(),
                data: {
                  status,
                  schedule: [cur],
                },
              },
            ];
          }

          return acc;
        }, []);
    },
    changeMonth(start, end, current) {
      console.log(222, this.collection)
      this.fetchSchedules(current);
    },
    eventClick(event, jsEvent, pos) {
      this.setDate(event.start);
      this.$router.push("/schedules/");
    },
    moreClick(day, events, jsEvent) {},
  },
};
</script>

<style>
.approved {
  background-color: #4dbd74 !important;
}
.draft {
  background-color: #ffc107 !important;
}
.declined {
  background-color: #f86c6b !important;
}
.events-day {
  min-height: 100px !important;
}
.events-day:hover {
  border: 1px solid #20a8d8 !important;
}
.custom-calendar-styles {
  padding: 0 !important;
  margin: 0 !important;
  max-width: initial !important;
}
.title {
  width: 125px !important;
}
.header-center {
  display: flex;
  justify-content: center;
}
</style>
